import React, { Suspense, lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Download, Github, Linkedin } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { translations } from '../translations/translations';
import { fadeUp, staggerContainer } from '../motion/presets';
import MagneticButton from './MagneticButton';
import '../styles/Hero.css';

const HeroBackground = lazy(() => import('../components/HeroBackground'));

export default function Hero() {
  const { language } = useAppContext();
  const t = translations[language];

  return (
    <section id="hero" className="hero">
      {/* Three.js Background */}
      <div className="hero__canvas-wrapper" aria-hidden="true">
        <Suspense fallback={null}>
          <HeroBackground />
        </Suspense>
      </div>

      {/* Gradient Overlay */}
      <div className="hero__overlay" />

      <div className="container hero__container">
        <motion.div
          className="hero__content"
          variants={staggerContainer(0.15, 0.2)}
          initial="hidden"
          animate="visible"
        >
          <motion.p className="hero__label" variants={fadeUp}>
            {t.hero.role}
          </motion.p>

          <motion.h1 className="hero__statement" variants={fadeUp}>
            {t.hero.statement}
          </motion.h1>

          <motion.p className="hero__name" variants={fadeUp}>
            {t.hero.name}
          </motion.p>

          <motion.div className="hero__actions" variants={fadeUp}>
            <MagneticButton className="hero__magnetic-cta" strength={0.12}>
              <a
                href="/"
                className="hero__cta hero__cta--primary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <span>{t.hero.cta.projects}</span>
                <ArrowDown size={16} />
              </a>
            </MagneticButton>
            <a
              href={`${process.env.PUBLIC_URL}/CV/Mert_Ozkaya_CV.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="hero__cta hero__cta--ghost"
            >
              <Download size={16} />
              <span>{t.hero.cta.downloadCV}</span>
            </a>
          </motion.div>

          <motion.div className="hero__social" variants={fadeUp}>
            <a
              href="https://github.com/Mertozkaya21"
              target="_blank"
              rel="noopener noreferrer"
              className="hero__social-link"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
            <a
              href="https://www.linkedin.com/in/mertozkaya1"
              target="_blank"
              rel="noopener noreferrer"
              className="hero__social-link"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
